module.exports = __webpack_public_path__ + "static_portal/img/christine_cavallo_good_video_example.b9fff094.jpg";